import { analyticsEventSchema, type AnalyticsEvent } from '@wolhasudang/shared';
import { db, type WolhasudangDb } from './db.js';
import { platform } from './platform.js';
import { sendAnalyticsEvents } from './api.js';

const appVersion = '0.1.0';
const contractVersion = '1';

export async function trackEvent(name: AnalyticsEvent['name'], properties: AnalyticsEvent['properties'] = {}, target: WolhasudangDb = db): Promise<void> {
  const event = analyticsEventSchema.parse({
    id: crypto.randomUUID(), name, channel: platform.channel, appVersion, contractVersion,
    releaseId: import.meta.env.VITE_RELEASE_ID || 'local', occurredAt: new Date().toISOString(), properties,
  });
  await target.outboxEvents.add({ createdAt: Date.now(), payload: event });
}

export async function flushAnalytics(target: WolhasudangDb = db, sender: (events: AnalyticsEvent[]) => Promise<void> = sendAnalyticsEvents): Promise<number> {
  const rows = await target.outboxEvents.orderBy('createdAt').limit(50).toArray();
  const accepted = rows.flatMap((row) => { const parsed = analyticsEventSchema.safeParse(row.payload); return parsed.success && row.id !== undefined ? [{ id: row.id, event: parsed.data }] : []; });
  if (!accepted.length) return 0;
  await sender(accepted.map((entry) => entry.event));
  await target.outboxEvents.bulkDelete(accepted.map((entry) => entry.id));
  return accepted.length;
}

export async function startAnalytics(): Promise<void> {
  await trackEvent('app_open');
  if (navigator.onLine) await flushAnalytics().catch(() => 0);
  window.addEventListener('online', () => { void flushAnalytics().catch(() => 0); });
}
